import React, { useRef } from "react";
import { theme } from "antd";
import type { CSSProperties } from "react";

type EditorOptions = Record<string, unknown>;

type EditorApp = {
  editor: {
    getEmail: () => string;
    getContent: () => string;
  };
};

type EditorSettings = EditorOptions & {
  content: string;
  subscribe: Record<string, (event: unknown) => void>;
};

type EditorWindow = Window & {
  app: {
    initialize: (settings: EditorSettings) => EditorApp;
  };
};

type Props = {
  height?: number;
  content?: string;
  options?: EditorOptions;
  bordered?: boolean;
  onChange?: (html: string, email: string) => void;
};

const DEFAULT_HEIGHT = 400;
const EDITOR_SRC = "/static/redactor.html";
const CHANGE_EVENT = "editor.change";

const noop = (): void => undefined;

const Redactor = ({
  height = DEFAULT_HEIGHT,
  content = "",
  options = {},
  bordered = true,
  onChange = noop,
}: Props): JSX.Element => {
  const iframe = useRef<HTMLIFrameElement>(null);

  const {
    token: {
      colorBorder,
      borderRadius,
    },
  } = theme.useToken();

  const onLoad = (): void => {
    // eslint-disable-next-line no-console
    console.info("Redactor.onLoad");

    const editorWindow = iframe.current.contentWindow as EditorWindow;

    const app = editorWindow.app.initialize({
      ...options,
      content,
      subscribe: {
        [CHANGE_EVENT]: () => {
          const html = app.editor.getContent();
          const email = app.editor.getEmail();

          onChange(html, email);
        },
      },
    });
  };

  const style: CSSProperties = {};

  if (bordered) {
    style.border = `1px solid ${colorBorder}`;
    style.borderRadius = borderRadius;
  }

  const iframeProps = {
    src: EDITOR_SRC,
    width: "100%",
    height: `${height}px`,
    frameBorder: "0",
    style,
    onLoad,
  };

  return (
    <div>
      <iframe
        ref={iframe}
        title="redactor"
        {...iframeProps}
      />
    </div>
  );
};

export default Redactor;
